document.addEventListener("DOMContentLoaded", function() {
    var tabs = document.querySelectorAll('[data-tab]');
    var tabbedContent = document.querySelectorAll('.tabs-body');

    if (!tabs) {
        return;
    }

    tabs.forEach(function(tab) {
        tab.addEventListener('click', function(e) {
            e.preventDefault();
            var target = e.target;
            var id = target.getAttribute('data-tab');
            var tabContent = document.getElementById(id);

            // remove active class from all tabs
            tabs.forEach(function(tab) {
                tab.classList.remove('is-active');
            });

            // remove active class from all tab content
            tabbedContent.forEach(function(content) {
                content.classList.remove('is-active');
            });

            // add active class to clicked tab
            target.classList.add('is-active');

            // add active class to corresponding tab content
            tabContent.classList.add('is-active');
        });
    });
});
